import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { FeedbackPage } from "./-components/FeedbackPage";
import { setProfileSubPageBodyColors } from "./-utils/profileHost";

const FeedbackSearch = z.object({
    embeddedApp: z.boolean().optional(),
});

export const Route = createFileRoute("/profile/feedback")({
    validateSearch: FeedbackSearch,
    component: FeedbackRoute,
    beforeLoad: () => {
        setProfileSubPageBodyColors(
            "var(--color-background-profile-secondary)",
            "var(--color-background-profile-secondary)",
        );
    },
    head: ({ match }) => ({
        meta: [{ title: `Feedback - ${match.search.tenant} ${match.search.locale}` }],
    }),
});

function FeedbackRoute() {
    const { embeddedApp = false } = Route.useSearch();

    return <FeedbackPage embeddedApp={embeddedApp} />;
}
